// ClientInfoRow.js
import React from 'react';
import CallButton from '../Global/CallBotton';  // Asegúrate de importar el componente CallButton

const ClientInfoRow = ({ order }) => {
  return (
    <span>
      <h4>Detalles del cliente</h4>
      <strong>Dni: </strong>{order.client?.dni || 'N/A'}
      <br />
      <strong>Correo: </strong>{order.client?.email || 'N/A'}
      <br />
      <strong>Teléfono: </strong>
      {order.client?.phone ? (
        <>
          <span>{order.client.phone}</span>
          <br />
          {/* Aquí se agrega el botón para llamar al teléfono */}
          <CallButton phoneNumber={order.client.phone} clientId={order.clientId} />
        </>
      ) : (
        'N/A'
      )}
      <br />
      <strong>Teléfono 2: </strong>
      {order.client?.phone2 ? (
        <>
          <span>{order.client.phone2}</span>
          <br />
          {/* Aquí se agrega el botón para llamar al teléfono */}
          <CallButton phoneNumber={order.client.phone2} clientId={order.clientId} />
        </>
      ) : (
        'N/A'
      )}
      <br />
      <strong>Fecha de nacimiento: </strong>
      {order.client?.dateOfBirth 
        ? new Date(order.client.dateOfBirth).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
        : 'N/A'}
      <br />
      <strong>Dirección de envío: </strong>
      {order.address 
        ? `${order.address.address || ''} ${order.address.city || ''}${order.address.district ? ` ${order.address.district}` : ''} ${order.address.zipCode || ''} ${order.address.state || ''} ${order.address.country || ''}`
        : 'N/A'} 
      <br />
      <strong>Dirección de facturación: </strong>
      {order.billingAddress 
        ? `${order.billingAddress.address || ''} ${order.billingAddress.city || ''}${order.billingAddress.district ? ` ${order.billingAddress.district}` : ''} ${order.billingAddress.zipCode || ''} ${order.billingAddress.state || ''} ${order.billingAddress.country || ''}`
        : 'N/A'}             
    </span>
  );
};

export default ClientInfoRow;
